import { audenc } from 'src/js/i18n/english/audenc.en.i18n';
import { base } from 'src/js/i18n/english/base.en.i18n';
import { dashboard } from 'src/js/i18n/english/dashboard.en.i18n';
import { essence } from 'src/js/i18n/english/essence.en.i18n';
import { logos } from 'src/js/i18n/english/logos.en.i18n';
import { metadata } from 'src/js/i18n/english/metadata.en.i18n';
import { scte } from 'src/js/i18n/english/scte.en.i18n';
import { security } from 'src/js/i18n/english/security.en.i18n';
import { settings } from 'src/js/i18n/english/settings.en.i18n';
import { statistics } from 'src/js/i18n/english/statistics.en.i18n';
import { stream } from 'src/js/i18n/english/stream.en.i18n';
import { validation } from 'src/js/i18n/english/validation.en.i18n';
import { videnc } from 'src/js/i18n/english/videnc.en.i18n';
import { whatsnew } from './english/whatsnew.en.i18n';

export const english = {
  ...audenc,
  ...base,
  ...dashboard,
  ...essence,
  ...logos,
  ...metadata,
  ...scte,
  ...settings,
  ...security,
  ...statistics,
  ...stream,
  ...validation,
  ...videnc,
  ...whatsnew,
};
